module.exports = __webpack_public_path__ + "img/index_03_nav_02.83a9df58.png";